export const ACCOUNT_FOLDERS_TAG_TYPE = 'AccountFolders' as const;
